import React, { useState } from 'react'
import styled from 'styled-components'
import PageTitle from '../../../_Components/Common/PageTitle/PageTitle'

const CustomProfile = props => {
  const {
    profileList,
    status,
    setStatus,
    getCustomProfile,
    updateCustomProfile,
    deleteAssistant,
    updateAssistantStatus,
  } = props

  const [statusList, setStatusList] = useState([
    { name: 'Reviewing', value: 'P' },
    { name: 'Approved', value: 'Y' },
    { name: 'Disapproved', value: 'N' },
    { name: 'All', value: 'all' },
  ])

  const getDate = d => {
    const date = new Date(d)
    const kstDate = new Date(
      date.toLocaleString('en-US', { timeZone: 'Asia/Seoul' })
    )

    const formatted =
      `${kstDate.getFullYear()}-` +
      `${String(kstDate.getMonth() + 1).padStart(2, '0')}-` +
      `${String(kstDate.getDate()).padStart(2, '0')} ` +
      `${String(kstDate.getHours()).padStart(2, '0')}:` +
      `${String(kstDate.getMinutes()).padStart(2, '0')}:` +
      `${String(kstDate.getSeconds()).padStart(2, '0')}`

    return formatted
  }

  return (
    <>
      <PageTitle
        mainTitle={'Profile Review'}
        v1Link={''}
        navNames={['Profile-Review']}
      />
      <SpaceResponsive height={10} />
      <section className="content">
        <div className="row">
          {/* <!-- Left col --> */}
          <section className="col-lg-12 connectedSortable">
            {/* <!-- Custom tabs (Charts with tabs)--> */}
            <div className="box box-info" style={{ padding: '0 10px' }}>
              {/* <!-- /.box-header --> */}
              <div className="box-body">
                <div style={{ marginTop: 10 }}>
                  <ButtonWrapper style={{ width: 'auto' }}>
                    {statusList.map((s, i) => (
                      <button
                        key={i}
                        style={{
                          backgroundColor:
                            status === s.value ? '#007bff' : '#6c757d',
                        }}
                        onClick={() => {
                          setStatus(s.value)
                        }}
                      >
                        {s.name}
                      </button>
                    ))}
                  </ButtonWrapper>
                  <SpaceResponsive height={10} />
                  <ImageWrapper>
                    {profileList.map((p, i) => (
                      <ImageBox key={i}>
                        <div
                          style={{
                            width: '100%',
                            height: '100%',
                            position: 'relative',
                          }}
                        >
                          <img id="profile" src={p.imgUrl} alt="" />
                          <div id="hover">
                            <div style={{ fontSize: '11px' }}>
                              {p.assistantId}
                            </div>
                            <div>{p.assistantName}</div>
                            <div>
                              {p.assistantStatus === 'Y'
                                ? 'Public'
                                : p.assistantStatus === 'U'
                                ? 'Unlisted'
                                : p.assistantStatus === 'P'
                                ? 'Private'
                                : 'Deactivated'}
                            </div>
                            <div>{p.userId}</div>
                            <div>{getDate(p.regDate)}</div>
                            <SpaceResponsive height={10} />
                            {p.status === 'P' && (
                              <div
                                style={{ display: 'flex', columnGap: '30px' }}
                              >
                                <img
                                  src="https://img.stipop.io/image/admin/check-icon.png"
                                  alt=""
                                  onClick={() => {
                                    updateCustomProfile(p.assistantId, 'Y')
                                  }}
                                />
                                <img
                                  src="https://img.stipop.io/image/admin/cancel-icon.png"
                                  alt=""
                                  onClick={() => {
                                    updateCustomProfile(p.assistantId, 'N')
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                        {p.status !== 'P' && (
                          <img
                            id="status"
                            src={`https://img.stipop.io/image/admin/${
                              p.status === 'Y' ? 'check' : 'cancel'
                            }-icon.png`}
                            alt=""
                          />
                        )}
                        <SpaceResponsive height={10} />
                        <div id="button-wrapper">
                          <button
                            style={{ background: '#6c757d' }}
                            onClick={() => {
                              updateAssistantStatus(p.assistantId)
                            }}
                          >
                            Unlisted
                          </button>
                          <button
                            onClick={() => {
                              deleteAssistant(p.assistantId)
                            }}
                            style={{
                              background: '#dc3545',
                            }}
                          >
                            Delete
                          </button>
                        </div>
                      </ImageBox>
                    ))}
                  </ImageWrapper>
                  <SpaceResponsive height={20} />
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
    </>
  )
}

export default CustomProfile

const SpaceResponsive = styled.div`
  height: ${props => props.height}px;
  flex-shrink: 0;
`

const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 10px;
`

const ImageBox = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  #profile {
    width: 100%;
    height: 100%;
    border-radius: 16px;
    object-fit: contain;
    aspect-ratio: 1 / 1;
  }

  #status {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 40px;
    height: 40px;
  }

  #button-wrapper {
    width: 100%;
    display: flex;
    column-gap: 8px;
    justify-content: center;

    button {
      width: 100%;
      border: none;
      outline: none;
      border-radius: 4px;
      color: #fff;
    }
  }

  #hover {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 16px;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    opacity: 0;
    transition: all 0.3s;

    img {
      width: 70px;
      height: 70px;
      cursor: pointer;
    }
  }

  &:hover #hover {
    opacity: 1;
  }
`

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 10px 0;

  button {
    height: 35px;
    padding: 0 10px;
    box-sizing: border-box;
    margin-left: 10px;
    color: #fff;
    border-radius: 5px;
    border: none;

    &:hover {
      opacity: 0.8;
    }
  }
`
